import moment from "moment";
export default function (angularModule) {
  angularModule.controller('billingAccountsSummaryCtrl', function (
    $scope, $rootScope, $log, $stateParams, $state, confirmService,
    billingAccountsService, $uibModal, $httpParamSerializer
  ) {


    /**
     *
     * Some View Models for filters
     */
    $scope.billingTypes = [
      {title: 'All', id: 'All'},
      {title: 'Customers', id: 'Customer'},
      {title: 'Demos', id: 'Demo'},
      {title: 'Test Accounts', id: 'Test'}
    ];


    $scope.dateModes = [{
      name: 'none',
      display: 'All'
    }, {
      name: '1-month',
      display: 'Month'
    }, {
      name: '3-month',
      display: 'Quarter'
    }];

    $scope.loadTags = (q) => billingAccountsService.queryTags(q);


    /**
     *
     * Some View Models for the BillingAccount table
     */
    $scope.columns = [
      {
        header: 'Created',
        sort: 'dateCreated',
        cell: (billingAccount) => moment(new Date(billingAccount.dateCreated)).format('M/D/YYYY')
      }, {
        header: 'Deactivated',
        sort: '_deleted',
        hide: () => $scope.showActive,
        cell: (billingAccount) => moment(new Date(billingAccount._deleted)).format('M/D/YYYY')
      }, {
        header: 'Name',
        sort: 'name',
        cell: (billingAccount) => billingAccount.name
      }, {
        header: 'Type',
        sort: 'billingType',
        hide: () => $scope.selectedBillingType.id !== 'All',
        cell: (billingAccount) => billingAccount.billingType
      }, {
        header: 'Tags',
        sort: 'tags',
        cell: (billingAccount) => billingAccount.tags && billingAccount.tags.join(", ")
      }, {
        header: '#Locations',
        cell: (billingAccount) => billingAccount.locationCounts.Total
      }, {
        header: '#Premium',
        cell: (billingAccount) => billingAccount.locationCounts.Premium
      }, {
        header: '#Audits',
        cell: (billingAccount) => billingAccount.locationCounts.Audit
      }, {
        header: 'Edit',
        actions: [
          {icon: 'fa-reply',  hover: 'Reactivate',                    hide: () =>  $scope.showActive, apply: reactivate},
          {icon: 'fa-pencil', hover: 'Edit Details',                  hide: () => !$scope.showActive, apply: createOrEdit},
          {icon: 'fa-user',   hover: 'View Account Admins',           hide: () => !$scope.showActive, apply: showUsers},
          {icon: 'fa-tasks',  hover: 'Change Location Subscriptions', hide: () => !$scope.showActive, apply: changeSubscription},
          {icon: 'fa-cogs',  hover: 'Configure',                     hide: () => !$scope.showActive, apply: configure},
          {icon: 'fa-usd',    hover: 'Configure Invoicing',
            hide: (bill) => !$scope.showActive || bill.billingType != 'Customer',
            apply: configureInvoicing},
          {icon: 'fa-trash',  hover: 'Deactivate',                    hide: () => !$scope.showActive, apply: deactivate}]
      }];

    $scope.sortByColumn = (column) => {
      if (column) {
        if ($scope.sortField === column) $scope.sortDirection = $scope.sortDirection * -1;
        else {
          $scope.sortDirection = 1;
          $scope.sortField = column;
        }
        $scope.loadResults();
      }
    };

    /**
     *
     * Initialize the filters from query params. Also some scoped helper functions for manipulating dates
     */

    function dateMode(name) {
      return $scope.dateModes.find((x) => x.name === name) || dateMode('none');
    }

    var lowerBound = moment('2016-06-01');
    var upperBound = moment();

    $scope.displayDatePeriod = () => {
      var m = moment($scope.startDate);
      if ($scope.dateMode.name === '3-month') return m.format('[Q]Q YYYY');
      else return m.format('MMMM YYYY');
    };

    $scope.peekShiftedDate = (multiple, enforceBounds = true) => {
      var quantity = $scope.dateMode.name === '3-month' ? 3 : 1;
      var shifted = moment($scope.startDate).add(quantity * multiple, 'months');
      if (enforceBounds && (shifted.isBefore(lowerBound) || shifted.isAfter(upperBound))) return null;
      else return shifted;
    }

    var _dateMode = dateMode($stateParams.dateMode);

    Object.assign($scope, {
      selectedBillingType: $scope.billingTypes.find(x => x.id == ($stateParams.billingType || 'All')),
      pageIndex: $stateParams.pageIndex || 1,
      pageSize: $stateParams.pageSize || 20,
      sortField: $stateParams.sortField || 'name',
      query: $stateParams.q,
      selectedIgnoreTags: ($stateParams.ignoreTags && $stateParams.ignoreTags.split(',').map(text => ({ text }))) || [],
      selectedTags: ($stateParams.tags && $stateParams.tags.split(',').map(text => ({ text }))) || [],
      showActive: angular.isUndefined($stateParams.showActive) ? true : $stateParams.showActive,
      includeAuditLocations: false,
      sortDirection: $stateParams.sortDirection,
      dateMode: _dateMode,
      startDate: (() => {
        if (_dateMode.name === 'none') return null;
        else {
          var specified = moment($stateParams.startDate);
          if (!specified.isValid()) specified = moment();

          specified.startOf(_dateMode.name === '3-month' ? 'quarter' : 'month');
          return specified.toDate()
        }
      })()
    });


    /**
     * Functions controlling actions/popups performed on individual Billing Accounts
     */
    function createOrEdit(billingAccount = {}) {
      var instance = $uibModal.open({
        template: require('./billingAccountEditor.html'),
        controller: 'billingAccountEditorCtrl',
        resolve: {
          billingAccount: () => billingAccount
        },
        size: "lg"

      });
      instance.result.then(reload)
    }

    function showUsers(billingAccount) {
      $uibModal.open({
        template: require('./adminUserInfo.html'),
        controller: 'adminUserInfoCtrl',
        resolve: {
          users: () => billingAccountsService.users(billingAccount._id).then(response => response.data),
          billingAccount: () => billingAccount
        },
        size: "lg"
      });

    }

    function deactivate(billingAccount) {
      confirmService.confirm(
        'Are you sure you want to deactivate this account?',
        'Deactivating an account will prevent existing account users from logging in, ' +
        'and set all premium locations to audits. For large accounts this can take some time.',
        confirmService.DELETE
      ).then((yesOrNo) => {
        if (yesOrNo) {
          $scope.loading = true;
          return billingAccountsService
            .deactivate(billingAccount._id)
            .then(reload, handleHttpError)
        }
      });
    }

    function changeSubscription(billingAccount) {
      confirmService.prompt({
        heading: 'Update subscription type for all locations',
        message: 'Select a subscription Type',
        theme: confirmService.QUESTION,
        actions: [{
          resolve: 'Premium', label: 'Premium', btnType: 'btn-primary'
        }, {
          resolve: 'Audit', label: 'Audit', btnType: 'btn-primary'
        }, {
          reject: null, label: 'Cancel'
        }]
      }).then(({ value: premiumOrAudit }) => {
        $scope.loading = true;
        billingAccountsService.changeSubscriptionType(billingAccount._id, premiumOrAudit)
          .then(reload, handleHttpError)
      });


    }

    function reactivate(billingAccount) {
      confirmService.prompt({
        header: 'Do you want to reactivate this account\'s locations?',
        message: 'When this billing account was cancelled, it\'s active locations were set to Audits in order to not run daily. ' +
        'Do you want to reactivate those locations? You will not be able to automatically reactivate the locations after this point.',
        actions: [{
         label: 'Yes', btnType: 'btn-primary', resolve: true
        }, {
          label: 'No', resolve: false
        }, {
          label: 'Cancel', reject: null
        }],
        theme: confirmService.QUESTION
      }).then(({ value: shouldReactivate }) => {
        $scope.query = billingAccount.name;
        $scope.showActive = true;
        $scope.loading = true;
        billingAccountsService.reactivate(billingAccount._id, shouldReactivate).then(reload, handleHttpError)
      })
    }

    function configure(billingAccount) {
      $uibModal.open({
        template: require('./configEditor.html'),
        controller: "configEditorCtrl",
        resolve: {
          userAccountId: () => $scope.userInfo.accountId,
          billingAccount: () => billingAccount
        },
        size: "lg"
      });
    }

    function configureInvoicing(billingAccount) {
      $uibModal.open({
        template: require('./invoicingEditor.html'),
        controller: "invoicingEditorCtrl",
        resolve: {
          userAccountId: () => $scope.userInfo.accountId,
          billingAccount: () => billingAccount
        },
        size: "lg"
      });
    }

    $scope.create = createOrEdit;

    /**
     *
     * Specialized Filter setters
     */

    $scope.setBillingType = (billingType) => {
      $scope.selectedBillingType = billingType;
      $scope.pageIndex = $scope.uibPageIndex = 1;
      $scope.loadResults();
    };

    $scope.shiftStartDate = (multiple) => {
      var shifted = $scope.peekShiftedDate(multiple);
      if (shifted) {
        $scope.startDate = shifted.toDate();
        $scope.loadResults()
      }

    };

    /**
     *
     * Everything else... Querying exports, mutating filters, and requesting Data Models
     */

    function handleHttpError(error) {
      if (error.status >= 300) {
        $log.error(error);
        $scope.loading = false;
        $scope.error = error;
      }
    }


    $scope.exportLoading = [];
    $scope.export = (exportName, extraFilters = {}) => {
      $scope.exportLoading.push(exportName);
      billingAccountsService.downloadExport(exportName, Object.assign(scopeToFilters(), extraFilters)).then(() => {
        $scope.exportLoading.pop()
      })
    };

    $scope.exportActiveListingHistory = () => {
      if ($scope.dateMode.name == '1-month') {
        var possibleProviders = ["ApartmentRatings", "Yelp"];
        confirmService.confirmWithOptions({
          theme: confirmService.QUESTION,
          initialModel: {
            diff: true, includeChatmeterFields: false,
            possibleProviders, provider: possibleProviders[0]
          },
          heading: 'Apartment Ratings Export Options',
          template: `
          <div class="form-group">
            <label>Provider:</label>
            <select class="form-control" ng-options="provider for provider in possibleProviders" ng-model="provider"></select>
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox" ng-model="diff" />
              Only Show Differences from Previous Month
            </label>
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox" ng-model="includeChatmeterFields" />
              Include Chatmeter Columns (IDs, and Names)
            </label>
          </div>`,
        }).then(({ diff, provider, includeChatmeterFields }) => {
          $scope.export('apartmentRatings', { diff, provider, includeChatmeterFields })
        })
      }
    }

    function scopeToFilters() {
      var billingType = $scope.selectedBillingType.id == 'All' ? null : $scope.selectedBillingType.id;
      var tags = ($scope.selectedTags && $scope.selectedTags.map((x) => x.text).join(',')) || null;
      var ignoreTags = ($scope.selectedIgnoreTags && $scope.selectedIgnoreTags.map((x) => x.text).join(',')) || null;
      var startDate = null;
      var endDate = null;
      if ($scope.dateMode.name !== 'none') {
        startDate = moment($scope.startDate);
        endDate = $scope.peekShiftedDate(1, false)
      }
      return {
        includeAuditLocations: $scope.includeAuditLocations,
        billingType: billingType,
        isActive: $scope.showActive,
        q: $scope.query,
        ignoreTags: ignoreTags,
        tags: tags,
        startDate: startDate && startDate.format('YYYY-MM-DD'),
        endDate: endDate && endDate.format('YYYY-MM-DD')
      }
    }

    function reload() {
      return $scope.loadResults(true)
    }

    $scope.loadResults = (reload = false) => {
      $scope.pageIndex = $scope.uibPageIndex;

      var searchParams = {
        pageIndex: $scope.pageIndex,
        sortField: $scope.sortField,
        billingType: $scope.selectedBillingType.id,
        q: $scope.query,
        ignoreTags: $scope.selectedIgnoreTags.map(x => x.text).join(',') || null,
        tags: $scope.selectedTags.map(x => x.text).join(',') || null,
        showActive: $scope.showActive,
        sortDirection: $scope.sortDirection,
        dateMode: $scope.dateMode.name,
        startDate: $scope.startDate && moment($scope.startDate).format('YYYY-MM-DD')
      };
      $scope.uibPageIndex = $scope.pageIndex; // uibPagination is a little aggressive about setting this, keep it separate
      $state.go('chatmeterAccountAdmin.billingAccounts', searchParams, { reload });

    };


    // finally initialize
    $scope.loading = true;
    $scope.error = null;
    $scope.pageSummary = 'loading...';
    $scope.billingAccounts = [];
    billingAccountsService.listBillingAccounts(
      Object.assign({
        start: ($scope.pageIndex - 1) * $scope.pageSize,
        limit: $scope.pageSize,
        sortField: $scope.sortField,
        sortDirection: $scope.sortDirection
      }, scopeToFilters()))
      .success((resultSet) => {
        $scope.loading = false;
        $scope.uibPageIndex = $scope.pageIndex;
        $scope.billingAccounts = resultSet.results;
        $scope.totalBillingAccounts = resultSet.count;
        $scope.pageSummary = `${$scope.pageIndex * $scope.pageSize + 1} to ${Math.min(($scope.pageIndex + 1) * $scope.pageSize, resultSet.count)} of ${resultSet.count}`;
      })
      .catch(handleHttpError);
  })
};
